"use client";

import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "src/components/ui/dialog";
import { Button } from "src/components/ui/button";

const COOKIE_CONSENT_KEY = "cookie_consent";

export function CookieConsent() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen}>
      <DialogContent
        position="bottom"
        hideCloseButton
        className="flex flex-col items-center gap-x-4 gap-y-2 sm:flex-row"
      >
        <div className="flex-1">
          <DialogTitle>Consentimento de Cookies</DialogTitle>
          <DialogDescription>
            Este site utiliza cookies para garantir que você tenha a melhor
            experiência. Ao continuar a navegar, você concorda com o uso de
            cookies, em conformidade com a nossa Política de Privacidade e com a
            LGPD do Brasil.
          </DialogDescription>
        </div>
        <Button
          type="button"
          variant="primary"
          size="primary"
          onClick={handleAccept}
          className="w-full sm:w-auto"
        >
          Aceitar e continuar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
